/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Segment } from "semantic-ui-react";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { selectCurrentUserApiToken, selectCurrentUserFavoriteFois, selectCurrentUserId, selectCurrentUserNotificationFois } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { FavoriteResourcesSection } from "./FavoriteResourcesPage";
import { ResourceNotificationsSection } from "./NotificationsForResources";
import { changeTool } from "../slices/footer/footerSlice";
import { changeFoiFocus } from "../slices/foiOfFocus/foiOfFocusSlice";
import getResourcesList from "../functions/getResourcesListAPI";
import NotificationsView from "./NotificationsView";
import { SavedSearchesSection } from "./SavedSearchesPage";
import { favoriteResourcesCollapsed, favoriteResourcesExpanded, followedResourcesCollapsed, followedResourcesExpanded, myResourcesListCollapsed, myResourcesListExpanded, notificationsCollapsed, notificationsExpanded, savedSearchesCollapsed, savedSearchesExpanded, selectFavoriteResourcesExpanded, selectFollowedResourcesExpanded, selectMyResourcesListExpanded, selectNotificationsExpanded, selectSavedSearchesExpanded } from "../slices/myFevirExpanded/myFevirExpandedSlice";
import get30dayViewHistory from "../functions/get30dayViewHistoryAPI";

const ResourceListSection = ({ resourcesListState, setResourcesListState }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    let resourcesLinks = [];
    for (let resourceType of resourcesListState.visibleResourceTypes) {
        let resourceList = resourcesListState.resourceDictionary[resourceType];
        resourcesLinks.push(<>
            <div className="resourceListHeader"
                onClick={() => {
                    let expanded = resourcesListState[resourceType + "expanded"];
                    if (expanded === undefined) {
                        expanded = false;
                    }
                    if (expanded) {
                        expanded = false;
                    } else {
                        expanded = true;
                    }
                    setResourcesListState((prevstate) => {
                        return {
                            ...prevstate,
                            [resourceType + "expanded"]: expanded
                        };
                    });
                }}>
                <div style={{ paddingTop: "20px" }} className="resourceListHeaderText">
                    <div>
                        <span>{resourceType + " Resources"} <b style={{ color: "#0000D0" }}>{(!resourcesListState[resourceType + "expanded"]) ? "▶" : "▼"}</b></span>
                    </div>
                </div>
                {(!resourcesListState[resourceType + "expanded"]) &&
                    <div style={{ paddingTop: "0px", paddingBottom: "0px" }}
                        className="resourceListHeaderExpand">
                        {/*<p style={{color: "blue"}}><b>E X P A N D</b></p>*/}
                    </div>
                }
            </div>
            {(resourcesListState[resourceType + "expanded"] &&
                resourcesListState.projectResourcesList.length === 1 &&
                resourcesListState.projectResourcesList[0] === "") &&
                <>{resourceList ?
                    <div style={{ "textAlign": "left" }}>
                        {resourceList?.map((resource, resourceIndex) => {
                            return <div style={{ paddingTop: "0px", paddingBottom: "4px" }} key={resourceIndex}>
                                <Link to={`/resources/${resource.resourcetype}/${resource.id}`}>
                                    <span style={{ fontSize: "24px" }}>{resource.title}</span>
                                </Link><span>{resource.status === "draft" && <>&nbsp;&nbsp;(draft)</>}</span>
                                <br />
                            </div>
                        })}
                    </div>
                    :
                    <>
                        <>
                            <img style={{ height: "22px" }} src="/spinner.gif" alt="Loading" />
                            <span style={{ fontSize: "larger" }}> Loading resources...</span>
                        </>
                    </>
                }</>
            }
        </>);
    }

    const loadResources = async () => {
        dispatch(globalLoadingOn());
        try {
            let resourceListByType;
            let resourceTypesList;
            let response = await getResourcesList(apiToken);
            if (response?.success) {
                resourceListByType = response.resourceListByType;
                resourceTypesList = Object.keys(resourceListByType)
                resourceTypesList.sort();
                setResourcesListState((prevState) => {
                    return {
                        ...prevState,
                        resourceDictionary: resourceListByType || null,
                        allResourceTypes: resourceTypesList, //the distinction between allResourceTypes and visibleResourceTypes is lost in this rewrite, will need to determine what is desired if needed to add back
                        visibleResourceTypes: resourceTypesList,
                        //resourcesTypeOptions: resourceTypeOptions,
                        loading: false,
                        displayLinks: true
                    };
                });
                //setLoadedState(true);
            }
        } catch (e) { console.log(e); }
        dispatch(globalLoadingOff())
    }

    useEffect(() => {
        if (apiToken) {
            //console.log("LOADING");
            if (resourcesListState.loading) {
                loadResources();
            }
        }
        //dispatch(triggerRefreshOn());
        dispatch(changeFoiFocus(""));
    }, [apiToken]);

    return <>{resourcesLinks?.map((resourceLink, index) => { return <div key={index}>{resourceLink}</div> })}</>;
}

const FhirResourcesLinks = ({ resourcesListState, setResourcesListState }) => {

    const dispatch = useDispatch();
    const myResourcesListIsExpanded = useSelector(selectMyResourcesListExpanded);

    return <div style={{ paddingTop: "4px" }}>

        <>{myResourcesListIsExpanded ?
            <ResourceListSection resourcesListState={resourcesListState} setResourcesListState={setResourcesListState} />
            :
            <h2 style={{ "cursor": "pointer", "textAlign": "center" }}
                onClick={() => { dispatch(myResourcesListExpanded()); }}>All My Resources <span style={{ color: "#0000D0" }}>▶</span></h2>
        }</>
    </div>
};

const MyRecentViewsSection = ({ myRecentViewsExpandedState }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);

    const [resourceListState, setResourceListState] = useState([]);

    const getRecentResourceList = async () => {
        let resourceList = await get30dayViewHistory(apiToken);
        setResourceListState(resourceList);
    };

    useEffect(() => {
        if (myRecentViewsExpandedState === true) {
            getRecentResourceList();
        }
    }, [myRecentViewsExpandedState]);

    return <div>
        {myRecentViewsExpandedState === true &&
            <>{resourceListState.length > 0 ?
                <div style={{ "textAlign": "left" }}>
                    {resourceListState?.map((resource, resourceIndex) => {
                        return <div style={{ paddingTop: "0px", paddingBottom: "4px" }} key={resourceIndex}>
                            <Link to={`/resources/${resource.resourcetype}/${resource.id}`}>
                                <span style={{ fontSize: "24px" }}>{resource.title}</span>
                            </Link><span>{resource.status === "draft" && <>&nbsp;&nbsp;(draft)</>}</span>
                            <br />
                        </div>
                    })}
                </div>
                :
                <>
                    <>
                        <img style={{ height: "22px" }} src="/spinner.gif" alt="Loading" />
                        <span style={{ fontSize: "larger" }}> Loading resources...</span>
                    </>
                </>
            }</>
        }
    </div>
}

// eslint-disable-next-line no-empty-pattern
const ContentResourcesPage = ({ }) => {
    const dispatch = useDispatch();

    const favoriteFois = useSelector(selectCurrentUserFavoriteFois);
    const followedFois = useSelector(selectCurrentUserNotificationFois);
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    const savedSearchesIsExpanded = useSelector(selectSavedSearchesExpanded);
    const followedResourcesIsExpanded = useSelector(selectFollowedResourcesExpanded);
    const favoriteResourcesIsExpanded = useSelector(selectFavoriteResourcesExpanded);
    const notificationsIsExpanded = useSelector(selectNotificationsExpanded);

    const [myRecentViewsExpandedState, setMyRecentViewsExpandedState] = useState(false);
    const [resourcesListState, setResourcesListState] = useState({
        resourcesList: [], resourceTypes: [],
        allResourceTypes: [], visibleResourceTypes: [], resourcesTypeOptions: [], resourceDictionary: {},
        projectsList: [], projectResourcesList: [""], projectResourcesDict: {},
        resourceTypeList: [], filterByResourceType: [], filterByProject: [],
        resourceTypeMenuIsOpen: false, viewing: "all", expandAll: true,
        citationexpanded: false, loading: true, resourceTypesLoading: true
    });

    useEffect(() => {
        if (!userId) {
            dispatch(notificationsCollapsed());
            dispatch(followedResourcesCollapsed());
            dispatch(favoriteResourcesCollapsed());
            dispatch(savedSearchesCollapsed());
            dispatch(myResourcesListCollapsed());
        }
    }, [userId]);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Favorites"));
        dispatch(changeTool("My FEvIR®"));
    }, [])

    return (
        <div>
            <Segment className={`containerSegment remainderOfPageSegment`} raised>
                {isLoggedIn ?
                    <>
                        <div className="resourceListHeader"
                            onClick={() => {
                                if (notificationsIsExpanded === true) {
                                    dispatch(notificationsCollapsed());
                                } else {
                                    dispatch(notificationsExpanded());
                                }
                            }}>
                            <div style={{ paddingTop: "20px" }} className="resourceListHeaderText">
                                <div>
                                    <span>
                                        <span style={{ color: "#C4941C" }}>My Notifications</span> <b
                                            style={{ color: "#0000D0" }}>{(!notificationsIsExpanded) ? "▶" : "▼"}</b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {notificationsIsExpanded && <NotificationsView />}
                        {favoriteFois.length > 0 &&
                            <div>
                                <div className="resourceListHeader"
                                    onClick={() => {
                                        if (favoriteResourcesIsExpanded === true) {
                                            dispatch(favoriteResourcesCollapsed());
                                        } else {
                                            dispatch(favoriteResourcesExpanded());
                                        }
                                    }}>
                                    <div style={{ paddingTop: "20px" }} className="resourceListHeaderText">
                                        <div>
                                            <span>
                                                <span style={{ color: "#C4941C" }}>All My Favorite Resources</span> <b
                                                    style={{ color: "#0000D0" }}>{(!favoriteResourcesIsExpanded) ? "▶" : "▼"}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {favoriteResourcesIsExpanded && <FavoriteResourcesSection />}
                            </div>
                        }
                        {followedFois.length > 0 &&
                            <div>
                                <div className="resourceListHeader"
                                    onClick={() => {
                                        if (followedResourcesIsExpanded === true) {
                                            dispatch(followedResourcesCollapsed());
                                        } else {
                                            dispatch(followedResourcesExpanded());
                                        }
                                    }}>
                                    <div style={{ paddingTop: "20px" }} className="resourceListHeaderText">
                                        <div>
                                            <span>
                                                <span style={{ color: "#C4941C" }}>Resources I am Following</span> <b
                                                    style={{ color: "#0000D0" }}>{(!followedResourcesIsExpanded) ? "▶" : "▼"}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {followedResourcesIsExpanded && <ResourceNotificationsSection />}
                            </div>}
                        <div style={{ paddingTop: "20px" }} className="resourceListHeader"
                            onClick={() => {
                                if (savedSearchesIsExpanded === true) {
                                    dispatch(savedSearchesCollapsed());
                                } else {
                                    dispatch(savedSearchesExpanded());
                                }
                            }}>
                            <div className="resourceListHeaderText">
                                <div>
                                    <span>
                                        <span style={{ color: "#C4941C" }}>My Searches</span> <b
                                            style={{ color: "#0000D0" }}>{(!savedSearchesIsExpanded) ? "▶" : "▼"}</b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {savedSearchesIsExpanded && <SavedSearchesSection />}
                        <div style={{ paddingTop: "20px" }} className="resourceListHeader"
                            onClick={() => {
                                setMyRecentViewsExpandedState(!myRecentViewsExpandedState);
                            }}>
                            <div className="resourceListHeaderText">
                                <div>
                                    <span>
                                        <span style={{ color: "#C4941C" }}>My Recent Views</span> <b
                                            style={{ color: "#0000D0" }}>{(!myRecentViewsExpandedState) ? "▶" : "▼"}</b>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {myRecentViewsExpandedState &&
                            <MyRecentViewsSection myRecentViewsExpandedState={myRecentViewsExpandedState} />}

                        {(resourcesListState.loading === false && resourcesListState.displayLinks !== false &&
                            resourcesListState.visibleResourceTypes.length === 0)
                            ?
                            <h1>You haven't created any resources yet.</h1>
                            :
                            <>
                                <FhirResourcesLinks resourcesListState={resourcesListState}
                                    setResourcesListState={setResourcesListState} />
                            </>
                        }
                    </>
                    :
                    <h1>Please login to view your resources</h1>
                }
            </Segment>
        </div>
    );
};

export default ContentResourcesPage;